const getReduxHeaders = (getState) => {
  const { languageToTranslate } = getState().auth;

  const actualLang = languageToTranslate === "it" ? "lc" : languageToTranslate;
  const header = { lang: actualLang };

  return { ...header };
};

export default getReduxHeaders;
